/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmployeeFileIncludeFilterItems } from './employeeFileIncludeFilterItems';
import { EmployeeFileScopeFilter } from './employeeFileScopeFilter';


export interface EmployeeFileIncludeFilterInner { 
    relation?: EmployeeFileIncludeFilterInner.RelationEnum;
    scope?: EmployeeFileScopeFilter;
}
export namespace EmployeeFileIncludeFilterInner {
    export type RelationEnum = 'user' | 'company' | 'catalog';
    export const RelationEnum = {
        User: 'user' as RelationEnum,
        Company: 'company' as RelationEnum,
        Catalog: 'catalog' as RelationEnum
    };
}


